import klaprozen1 from "../assets/garden/klaprozen-1.png";
import klaprozen2 from "../assets/garden/klaprozen-2.png";
import klaprozen3 from "../assets/garden/klaprozen-3.png";
import paardenbloem1 from "../assets/garden/paardenbloem-1.png";
import paardenbloem2 from "../assets/garden/paardenbloem-2.png";
import paardenbloem3 from "../assets/garden/paardenbloem-3.png";
import lavendel1 from "../assets/garden/lavendel-1.png";
import lavendel2 from "../assets/garden/lavendel-2.png";
import lavendel3 from "../assets/garden/lavendel-3.png";
import waardenboom1 from "../assets/garden/waardenboom-1.png";
import waardenboom2 from "../assets/garden/waardenboom-2.png";
import waardenboom3 from "../assets/garden/waardenboom-3.png";
import stappenpad1 from "../assets/garden/stappenpad-1.png";
import stappenpad2 from "../assets/garden/stappenpad-2.png";
import stappenpad3 from "../assets/garden/stappenpad-3.png";
import struik1 from "../assets/garden/struik-1.png";
import struik2 from "../assets/garden/struik-2.png";
import struik3 from "../assets/garden/struik-3.png";

export const GARDEN_ASSETS: Record<string, readonly string[]> = {
  klaprozen: [klaprozen1, klaprozen2, klaprozen3],
  paardenbloem: [paardenbloem1, paardenbloem2, paardenbloem3],
  lavendel: [lavendel1, lavendel2, lavendel3],
  waardenboom: [waardenboom1, waardenboom2, waardenboom3],
  stappenpad: [stappenpad1, stappenpad2, stappenpad3],
  struik: [struik1, struik2, struik3],
};

/** tier 1–3 → asset index 0–2 */
export function getGardenAssetUrl(prefix: string, tier: number): string | undefined {
  const assets = GARDEN_ASSETS[prefix];
  if (!assets) return undefined;
  const index = Math.max(0, Math.min(assets.length - 1, tier - 1));
  return assets[index];
}
